import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { PositionDocument, positionPullQueryBuilder } from './queryBuilder';

export function positionsFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<PositionDocument> {
  const syncConfig = configBuilder<PositionDocument>(RxdbCollectionNameV2.POSITIONS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, positionPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.POSITIONS, replicationState, [sites]);
}
